
import Checkbox from '@mui/material/Checkbox'
import {ThumbUpAlt,ThumbUpAltOutlined,Check,CheckBox} from '@mui/icons-material'
import { FormControl, FormControlLabel } from '@mui/material'
interface iProps {label:string,value:boolean,setValue?:Function,disabled:boolean}
export default function MyCheckBox ({label,value,setValue=()=>{},disabled=false}:iProps){



    return (
      <FormControlLabel
      label={label}
       sx={{
      
           '& .MuiFormControlLabel-label.Mui-disabled':{
             color:value?'var(--primary-color)':'gray'
           }
         
      
       }}
      control={
        
        <Checkbox
      
        checked={value}
        onChange={(e:React.ChangeEvent<HTMLInputElement>)=>setValue(e.target.checked)}
       
        sx={{border:value? '2px solid var(--primary-color)':'1px solid gray',margin:'0 4px'}}
        disabled={disabled}
        inputProps={{'aria-label':'label'}}
  icon={
<Check sx={{color:'gray'}} />}
  checkedIcon={<Check sx={{color:'var(--primary-color)',fontWeight:'bold'}} />}
/>
      }/>

           
     
    )
}